import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';
import { SoilProps } from 'utils/types';

export const fileKey = ['fileSoil'];

const useCroptimizerSoil = () => useQuery({
  queryKey: [fileKey, 'croptimizer'],
  queryFn: () => agent.getClient()('file-data/croptimizer?tag=soils').then((response) => {
    const result: SoilProps[] = [];
    response?.data?.data?.forEach((element: any) => {
      result.push({
        ['Country']: element?.['0'],
        ['Soils']: element?.['1'],
        ['CEC']: element?.['2'],
        ['pHImprovements']: element?.['3'],
        ['pHMaintenance']: element?.['4'],
      });
    });

    return result as SoilProps[];
  }),
  staleTime: 5 * 60 * 1000,
  gcTime: 10 * 60 * 1000,
});

export default useCroptimizerSoil;
